"use strict";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileOnboardingService = void 0;
var MobileOnboardingService;
(function (MobileOnboardingService) {
  /**
   * @title YOL Service
   * @version 1.3.2
   * @license MIT
   * @baseUrl /mobile-onboarding
   * @contact YOL Digital <digital-yol@sunrise.net>
   *
   * yol-mobile-onboarding-service [ 📜 View Changelog](/mobile-onboarding/internal/release-note)
   */
  class Api {
    constructor(url, http) {
      this.public = {
        /**
        * No description
        *
        * @tags public
        * @name DoMobileOnboarding
        * @request GET:/mobile-onboarding/onboarding/mobile/{subscriptionId}
        * @secure bearerAuth
        * @response `200` `(StepResp)[]` Ok
        * @response `400` `{
        error: "ERR_SUBSCRIPTION_ALREADY_ACTIVE",
             }`
        * @response `404` `{
        error: "ERR_ORDER_NOT_FOUND",
             }`
        * @response `500` `{
        error: "ERR_SYSTEM_ERROR",
             }`
        */
        doMobileOnboarding: (subscriptionId, params = {}) => this.http.request("GET", `${this.url}/mobile-onboarding/onboarding/mobile/${subscriptionId}`, {
          ...params
        })
      };
      this.http = http;
      this.url = url;
    }
  }
  MobileOnboardingService.Api = Api;
})(MobileOnboardingService || (exports.MobileOnboardingService = MobileOnboardingService = {}));